const jaMessages = {
  /* 01.General */
  "chat.end": "チャットの会話を再開する",
  "chat.endall": "チャットを終了する",
  "chat.cancel": "キャンセル",
  "chat.cookie":
    "このデジタルアシスタントはCookieを使用して、最高のエクスペリエンスを提供します",
  "chat.learn": "もっと詳しく知る",
  "chat.minimize": "最小化",
  "chat.hide": "近い",
  "chat.hidebot.text": "閉じるとアバターが 15 分間消えます",
  "chat.hidebot": "ボットを閉じる",
  "chat.restart": "再起動",
  "switch.language": "言語の切り替え",
  "switch.property": "スイッチプロパティ",
  "restart.converstation": "会話を再開する",
  "chat.endtext": "現在のチャットを終了してもよろしいですか?",
  "check.availabity": "空室状況を確認する",
  "check.availabity.submit": "送信",
  "check.availabity.cancel": "キャンセル",
  "check.availabity.adults": "大人 ",
  "check.availabity.children": "子供",
  "check.availabity.child.age": "年齢 - 子",
  "feedback.leave": "フィードバックを残す",
  "feedback.leave.message": "メッセージを残す",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "ケースを送信する",
  "caseform.system": "システム",
  "caseform.loading.systems": "システムを読み込み中...",
  "caseform.select.system": "システムを選択",
  "caseform.error.systems": "システムの読み込みエラー",
  "caseform.scenario": "シナリオ",
  "caseform.loading.scenarios": "シナリオを読み込み中...",
  "caseform.select.scenario": "シナリオを選択",
  "caseform.error.scenarios": "シナリオの読み込みエラー",
  "caseform.topic": "トピック",
  "caseform.loading.topics": "トピックを読み込み中...",
  "caseform.select.topic": "トピックを選択",
  "caseform.error.topics": "トピックの読み込みエラー",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "件名",
  "caseform.description": "説明",
  "caseform.attachments": "添付ファイル",
  "caseform.attachments.remove": "削除",
  "caseform.submit": "送信",
  "caseform.cancel": "キャンセル",
  "caseform.success.title": "ケース作成完了",
  "caseform.success.message": "ケースが正常に作成されました。",
  "caseform.success.caseNumber": "ケース番号：",
  "caseform.success.transferToLiveAgent":
    "ライブエージェントに転送しています。",
  "caseform.success.newChatWindowRightSide":
    "ブラウザーの右側に新しいチャットウィンドウが開きます。",
  "caseform.success.ok": "OK",
  "simpleaction.title": "アクションを選択",
  "simpleaction.body":
    "次のオプションのいずれかを選択してください:{br}{b}ケースを作成{/b}サポートリクエストを送信するには、または{b}チャットを開始{/b}今すぐエージェントに接続するには。",
  "simpleaction.startchat": "チャットを開始",
  "simpleaction.createcase": "ケースを作成",
  "caseform.error.generic": "ケースの作成中にエラーが発生しました。",
  "caseform.error.generic.message":
    "ケースの作成中にエラーが発生しました。後でもう一度お試しください。",
};
export default jaMessages;
